import React, { useEffect, useState, useRef, FC } from 'react';
import fetchAPI from '../../../../common/fetchAPI';
import { ShowToast } from "../../../../common/Toastr";
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useTranslation } from "react-i18next";

const TimesheetApprovedEmail: FC = () => {
  const [timesheetData, setTimesheetData] = useState<any | ''>([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { REACT_APP_TIMELIVE_API_URL, NODE_ENV } = process.env;

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    // Extract query string parameters
    const employeeId = query.get('ApproverEmployeeId');
    const periodId = query.get('AccountEmployeeTimeEntryPeriodId');
    const QS = query.get('QS');
    getTimesheetApprovedEmail(employeeId, periodId, QS);
  }, [])

  const getTimesheetApprovedEmail = async (employeeId: any, periodId: any, QS: any) => {
    try {
      const requestData = {
        QS: QS
      };
      let base_url = window.origin + '/classic/';
    if (NODE_ENV === 'development') {
        base_url = REACT_APP_TIMELIVE_API_URL as string;
    }
    
    const response = await fetch(base_url + 'api/Account/SingleApproveTimesheetForMobileEncryptedValue', {
      // const response = await fetch('https://localdebug.livetecs.com/api/Account/SingleApproveTimesheetForMobileEncryptedValue', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      // If the response is successful
      if (response && response.status === 200) {
        const responseData = await response.json();
        setTimesheetData(responseData.Data); // Store fetched data
        if (responseData.Data.RejectedStatus) {
          ShowToast("Timesheet rejected successfully.", "Rejected", "error", "toast-top-right");
        } else {
          ShowToast("Timesheet approved successfully.", 'Success', "success", "toast-top-right");
        }
        // return responseData;  // resolve the response
      } else {
        // If the response is not OK, throw an error
        ShowToast("Failed to approve timesheet. Please try again.", 'Error', "error", "toast-top-right");
      }
    } catch (error) {
      // Handle errors
      throw error;
    }
  };


  const getTimesheetApprovedEmail1 = async (employeeId: any, periodId: any, QS: any) => {
    const apiUrl =
      "https://localdebug.livetecs.com/api/v2/Timesheets/SingleApproveTimesheetForMobileEncryptedValue";
    const requestData = {
      QS: QS
    };
    setLoading(true); // Set loading state to true while the API call is being made

    const response = await fetchAPI("api/V2/Timesheets/SingleApproveTimesheetForMobileEncryptedValue", "POST", requestData, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
    //const response = await fetchAPI("api/V2/Timesheets/SingleApproveTimesheetForMobile", "POST", requestData, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
    //const json = response.json();


    if (response && response.status === 200) {
      const json = await response.json(); // Wait for the Promise to resolve
      console.log("API Response:", json);

      setTimesheetData(json.Data); // Store fetched data
      console.log("timesheet appproval response", response)
      // Success scenario

      // Success scenario
      if (json.Data.RejectedStatus) {
        ShowToast("Timesheet rejected successfully.", "Rejected", "error", "toast-top-right");
      } else {
        ShowToast("Timesheet approved successfully.", 'Success', "success", "toast-top-right");
      }

    } else {
      // Error scenario
      ShowToast("Failed to approve timesheet. Please try again.", 'Error', "error", "toast-top-right");
    }

  }
  return (
    <>
<div className='mb-4'>
  {/* Image Section */}
  <div className="d-flex justify-content-center mb-3">
    <img
      className='mw-100 mh-100 theme-light-show rounded-circle shadow-sm'
      style={{ width: 50, height: 50 }}
      src={timesheetData.RejectedStatus ? toAbsoluteUrl('/media/images/Reject.png') : toAbsoluteUrl('/media/images/Approved.png')}
    />
  </div>
  
  {/* Title Section */}
  <h1 className='tsNavBarInfoText fw-bolder fs-1 text-gray-500 text-center mb-3'>
    {timesheetData.RejectedStatus ? "Timesheet has been rejected" : "Timesheet has been approved"}
  </h1>

  {/* Info Section */}
  <div className="p-4 mb-4 bg-white rounded-lg d-flex flex-column align-items-center">
    
    {/* Employee Name */}
    <div className="row mb-3">
      <div className="col-md-12" style={{ textAlign: 'center' }}>
        <span className="tsNavBarInfoText fw-semibold fs-6 text-gray-900">
          Employee Name
        </span>
      </div>
    </div>
    <div className="row mb-3">
      <div className="col-md-12" style={{ textAlign: 'center' }}>
        <span className="tsNavBarInfoLabel fs-6">
          {timesheetData.EmployeeName || 'N/A'}
        </span>
      </div>
    </div>

    <div className='separator my-2'></div>

    {/* Date Range */}
    <div className="row mb-3">
      <div className="col-md-12" style={{ textAlign: 'center' }}>
        <span className="tsNavBarInfoText fw-semibold fs-6 text-gray-900">
          Date Range
        </span>
      </div>
    </div>
    <div className="row mb-3">
      <div className="col-md-12" style={{ textAlign: 'center' }}>
        <span className="tsNavBarInfoLabel fs-6">
          {timesheetData.TimeEntryStartDate && timesheetData.TimeEntryEndDate
            ? `${timesheetData.TimeEntryStartDate} - ${timesheetData.TimeEntryEndDate}`
            : 'N/A'}
        </span>
      </div>
    </div>

    <div className='separator my-2'></div>

    {/* Hours */}
    <div className="row mb-3">
      <div className="col-md-12" style={{ textAlign: 'center' }}>
        <span className="tsNavBarInfoText fw-semibold fs-6 text-gray-900">
          Hours
        </span>
      </div>
    </div>
    <div className="row mb-3">
      <div className="col-md-12" style={{ textAlign: 'center' }}>
        <span className="tsNavBarInfoLabel fs-6">
          {timesheetData.Hours ? timesheetData.Hours : '0.0'}
        </span>
      </div>
    </div>
  </div>
</div>



{/* <div className='mb-4'>
   <div className="d-flex justify-content-center mb-3">
    <img 
      className='mw-100 mh-100 theme-light-show rounded-circle shadow-sm' 
      style={{ width: 50, height: 50 }} 
      src={timesheetData.RejectedStatus ? toAbsoluteUrl('/media/images/Reject.png') : toAbsoluteUrl('/media/images/Approved.png')} 
    />
  </div>
  
  <h1 className='tsNavBarInfoText fw-bolder fs-1 text-gray-500 text-center mb-3'>
    {timesheetData.RejectedStatus ? "Timesheet has been rejected" : "Timesheet has been approved"}
  </h1>

  <div className=" p-4 mb-4 bg-white rounded-lg">
    <div className="row mb-3 text-center">
      <div className="col-md-5 " 
      style={{width:'50%'}}
      >
        <span className=" tsNavBarInfoText fw-semibold fs-6 text-gray-900">
          Employee Name
        </span>
      </div>
      <div className="col-md-1 d-flex justify-content-center align-items-center">
        <div
          style={{
            borderLeft: '1px solid #ddd', // Color of the line
            height: '15px', // Adjust the height to your needs
            marginLeft: '10px', // Optional, adjusts the spacing from the label
          }}
        ></div>
      </div>
      <div className="col-md-5 " >
        <span className=" tsNavBarInfoLabel fs-6">
          {timesheetData.EmployeeName || 'N/A'}
        </span>
      </div>
    </div>

    <div className='separator my-2'></div>
    <div className="row mb-3 text-center">
      <div className="col-md-6 " 
      style={{width:'50%'}}
      >
        <span className=" tsNavBarInfoText fw-semibold fs-6 text-gray-900  ">
          Date Range
        </span>
      </div>
      <div className="col-md-1 d-flex justify-content-center align-items-center">
        <div
          style={{
            borderLeft: '1px solid #ddd', // Color of the line
            height: '15px', // Adjust the height to your needs
            marginLeft: '10px', // Optional, adjusts the spacing from the label
          }}
        ></div>
      </div>
      <div className="col-md-5 " >
        <span className=" tsNavBarInfoLabel fs-6">
          {timesheetData.TimeEntryStartDate && timesheetData.TimeEntryEndDate
            ? `${timesheetData.TimeEntryStartDate} - ${timesheetData.TimeEntryEndDate}`
            : "N/A"}
        </span>
      </div>
    </div>

    <div className='separator my-2'></div>

    
    <div className="row mb-3 text-center">
      <div className="col-md-6 " 
      style={{width:'50%'}}
      >
        <span className=" tsNavBarInfoText fw-semibold fs-6 text-gray-900">
          Hours
        </span>
      </div>
      <div className="col-md-1 d-flex justify-content-center align-items-center">
        <div
          style={{
            borderLeft: '1px solid #ddd', // Color of the line
            height: '15px', // Adjust the height to your needs
            marginLeft: '10px', // Optional, adjusts the spacing from the label
          }}
        ></div>
      </div>
      <div className="col-md-5  fs-6">
        <span className=" tsNavBarInfoLabel">
          {timesheetData.Hours ? timesheetData.Hours : "0.0"}
        </span>
      </div>
    </div>
  </div>
</div> */}




    {/* <div className='mb-2'>
    <img className='mw-100 mh-300px theme-light-show'
        style={{ width: 70, height: 70 }}
          src={timesheetData.RejectedStatus ? toAbsoluteUrl('/media/images/Reject.png') : toAbsoluteUrl('/media/images/Approved.png')} />
      </div>
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-2'>
     
        {timesheetData.RejectedStatus ? "Timesheet Reject Detail" : "Timesheet Approved Detail"}
        
      </h1>
      
      <div className="shadow-sm p-4 mb-2 bg-white rounded">

        <div className="row mb-2">
          <div className="col-md-6 text-start">
            <span className="text-uppercase tsNavBarInfoText fw-semibold fs-6 text-gray-500">Employee Name</span>
          </div>
          <div className="col-md-6 text-start">
            <span className="text-uppercase tsNavBarInfoLabel"> {timesheetData.EmployeeName || "N/A"}</span>
          </div>
        </div>


        <div className="row mb-2">
          <div className="col-md-6 text-start">
            <span className="text-uppercase tsNavBarInfoText fw-semibold fs-6 text-gray-500">Date Range</span>
          </div>
          <div className="col-md-6 text-start">
            <span className="text-uppercase tsNavBarInfoLabel">  {timesheetData.TimeEntryStartDate && timesheetData.TimeEntryEndDate
              ? `${timesheetData.TimeEntryStartDate} - ${timesheetData.TimeEntryEndDate}`
              : ""}</span>
          </div>
        </div>


        <div className="row mb-2">
          <div className="col-md-6 text-start">
            <span className="text-uppercase tsNavBarInfoText fw-semibold fs-6 text-gray-500">Hours</span>
          </div>
          <div className="col-md-6 text-start">
            <span className="text-uppercase tsNavBarInfoLabel">{timesheetData.Hours ? timesheetData.Hours : "0.0"}</span>
          </div>
        </div>
      </div> */}

     

      {/* <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>{timesheetData.RejectedStatus ? "Timesheet Reject Detail" : "Timesheet Approved Detail"}</h1>
      <div className="row">
        <div className="col-md-6">
          <span className="text-uppercase tsNavBarInfoText fw-semibold fs-6 text-gray-500 mb-7"  >Employee Name</span>
        </div>
        <div className="col-md-6">
          <span className="text-uppercase tsNavBarInfoLabel "> {timesheetData.EmployeeName || "N/A"}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <span className="text-uppercase tsNavBarInfoText fw-semibold fs-6 text-gray-500 mb-7" >Date Range</span>
        </div>
        <div className="col-md-6"><span className="text-uppercase tsNavBarInfoLabel"> {timesheetData.TimeEntryStartDate} - {timesheetData.TimeEntryEndDate}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <span className="text-uppercase tsNavBarInfoText fw-semibold fs-6 text-gray-500 mb-7" >Hours</span>
        </div>
        <div className="col-md-6"><span className="text-uppercase tsNavBarInfoLabel">{timesheetData.Hours}</span>
        </div>
      </div>
      <div className='mb-3'>
        <img className='mw-100 mh-300px theme-light-show'
          src={timesheetData.RejectedStatus ? toAbsoluteUrl('/media/images/Reject.png') : toAbsoluteUrl('/media/images/Approved.png')} />
      </div> */}
    </>
  )
}

export { TimesheetApprovedEmail }
